/**
 * Generate a Crockford-base32 8-char code shaped as `XXXX-XXXX`.
 *
 * ⚠️ **Stub / no-backend mode ONLY.** The real per-gateway claim endpoint is
 * live — `things.claim(id)` → `POST /v1/things/{id}/claim` (server-issued
 * base64url code, single-active, ~1h TTL). Live surfaces (onboarding wizard,
 * the Gateways detail-sheet mint/regenerate) call that and never this. This
 * fabricated code exists purely so the app demos an onboarding flow with no
 * backend; it is never a code the broker would accept.
 */

const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";

export function makeClaimCode(): string {
  const pick = () => ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
  const left = Array.from({ length: 4 }, pick).join("");
  const right = Array.from({ length: 4 }, pick).join("");
  return `${left}-${right}`;
}
